angular.module('unergie.main')
.config(($sceDelegateProvider) => {
    $sceDelegateProvider.resourceUrlWhitelist(['self', 'https://checkout.preprod.slimpay.com/**'])
})
